/* ─── CART DRAWER ─── */
class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    this.countEl = document.querySelectorAll('.cart-count');
    this.bodyEl = document.getElementById('cart-body');
    this.subtotalEl = document.getElementById('cart-subtotal-price');

    document.querySelectorAll('[data-open-cart]').forEach(el => {
      el.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
    });
    document.querySelectorAll('[data-close-cart]').forEach(el => {
      el.addEventListener('click', () => this.close());
    });
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-add-to-cart]')) this.addToCart(e);
      if (e.target.closest('[data-qty-change]')) this.changeQty(e);
      if (e.target.closest('[data-remove-item]')) this.removeItem(e);
    });
  }

  open() {
    this.refresh().then(() => {
      this.drawer?.classList.add('is-open');
      this.overlay?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  close() {
    this.drawer?.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async refresh() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    this.updateCount(cart.item_count);
    this.renderItems(cart);
  }

  updateCount(count) {
    this.countEl.forEach(el => {
      el.textContent = count > 0 ? count : '';
    });
  }

  renderItems(cart) {
    if (!this.bodyEl) return;
    if (cart.item_count === 0) {
      this.bodyEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      if (this.subtotalEl) this.subtotalEl.textContent = '';
      return;
    }
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: cart.currency });
    this.bodyEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item-img" src="${item.image}" alt="${item.title}">
        <div>
          <div class="cart-item-name">${item.product_title}</div>
          <div class="cart-item-variant">${item.variant_title || ''}</div>
          <div class="cart-item-controls">
            <div class="qty-control">
              <button class="qty-btn" data-qty-change data-key="${item.key}" data-delta="-1">−</button>
              <span class="qty-value">${item.quantity}</span>
              <button class="qty-btn" data-qty-change data-key="${item.key}" data-delta="1">+</button>
            </div>
            <span class="cart-item-price">${formatter.format(item.line_price / 100)}</span>
          </div>
        </div>
      </div>
    `).join('');
    if (this.subtotalEl) {
      this.subtotalEl.textContent = formatter.format(cart.total_price / 100);
    }
  }

  async addToCart(e) {
    const btn = e.target.closest('[data-add-to-cart]');
    const variantId = btn.dataset.variantId || document.querySelector('[name="id"]')?.value;
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      await res.json();
      this.open();
    } finally {
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
    }
  }

  async changeQty(e) {
    const btn = e.target.closest('[data-qty-change]');
    const key = btn.dataset.key;
    const delta = parseInt(btn.dataset.delta);
    const qtyEl = btn.closest('.qty-control').querySelector('.qty-value');
    const newQty = Math.max(0, parseInt(qtyEl.textContent) + delta);
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    this.refresh();
  }

  async removeItem(e) {
    const btn = e.target.closest('[data-remove-item]');
    const key = btn.dataset.key;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    this.refresh();
  }
}

/* ─── MOBILE MENU ─── */
class MobileMenu {
  constructor() {
    this.menu = document.getElementById('mobile-menu');
    this.overlay = document.getElementById('mobile-menu-overlay');
    document.querySelectorAll('[data-open-mobile-menu]').forEach(el => {
      el.addEventListener('click', () => this.open());
    });
    document.querySelectorAll('[data-close-mobile-menu]').forEach(el => {
      el.addEventListener('click', () => this.close());
    });
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());
  }
  open() {
    this.menu?.classList.add('is-open');
    this.overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  close() {
    this.menu?.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

/* ─── PRODUCT PAGE GALLERY ─── */
class ProductGallery {
  constructor() {
    const thumbs = document.querySelectorAll('.product-thumb');
    const slides = document.querySelectorAll('.gallery-slide');
    if (!thumbs.length || !slides.length) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const idx = parseInt(thumb.dataset.index, 10);
        thumbs.forEach(t => t.classList.remove('active'));
        slides.forEach(s => s.classList.remove('active'));
        thumb.classList.add('active');
        slides[idx].classList.add('active');
      });
    });
  }
}

/* ─── VARIANT SELECTOR ─── */
class VariantSelector {
  constructor() {
    const el = document.getElementById('product-variants-json');
    this.variants = el ? JSON.parse(el.textContent) : [];
    this.hiddenSelect = document.querySelector('select[name="id"]');
    this.addToCartBtns = document.querySelectorAll('[data-add-to-cart]');
    this.priceEl = document.querySelector('.product-price');

    document.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('.variant-group');
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const optionName = group.dataset.optionName || '';
        this.updateVariant(optionName);
      });
    });

    this.syncInitialVariant();
  }

  syncInitialVariant() {
    const firstVariant = this.variants.find(v => v.featured_image_index === 0);
    if (!firstVariant) return;

    document.querySelectorAll('.variant-group').forEach(group => {
      const anyBtn = group.querySelector('.variant-btn');
      if (!anyBtn) return;
      const pos = parseInt(anyBtn.dataset.optionPosition);
      const optValue = firstVariant[`option${pos}`];
      if (!optValue) return;
      group.querySelectorAll('.variant-btn').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.value === optValue);
      });
    });

    this.updateVariant('');
  }

  getSelectedOptions() {
    const options = {};
    document.querySelectorAll('.variant-group').forEach(group => {
      const active = group.querySelector('.variant-btn.active');
      if (active) options[parseInt(active.dataset.optionPosition)] = active.dataset.value;
    });
    return Object.keys(options).sort().map(k => options[k]);
  }

  // 現在選択中のオプションを {位置: 値} のマップで返す
  getSelectedMap() {
    const m = {};
    document.querySelectorAll('.variant-group').forEach(group => {
      const active = group.querySelector('.variant-btn.active');
      if (active) m[parseInt(active.dataset.optionPosition)] = active.dataset.value;
    });
    return m;
  }

  findVariant(options) {
    return this.variants.find(v => {
      const vo = [v.option1, v.option2, v.option3].filter(o => o != null);
      return vo.every((opt, i) => opt === options[i]);
    });
  }

  // 指定オプションマップに完全一致するバリアント
  findVariantByMap(map) {
    return this.variants.find(v =>
      Object.keys(map).every(pos => v['option' + pos] === map[pos])
    );
  }

  // バリアントに合わせて各オプショングループのアクティブボタンを同期
  syncButtonsToVariant(variant) {
    document.querySelectorAll('.variant-group').forEach(group => {
      const anyBtn = group.querySelector('.variant-btn');
      if (!anyBtn) return;
      const pos = parseInt(anyBtn.dataset.optionPosition);
      const val = variant['option' + pos];
      group.querySelectorAll('.variant-btn').forEach(b =>
        b.classList.toggle('active', b.dataset.value === val)
      );
    });
  }

  updateVariant(clickedOptionName = '') {
    let variant = this.findVariantByMap(this.getSelectedMap());

    // 完全一致なし（例: 選択中のサイズにその色が無い）→ クリックした
    // オプション（色など）を優先して在庫のあるバリアントへ自動補正し、画像も切り替える
    if (!variant) {
      let clickedPos = null;
      document.querySelectorAll('.variant-group').forEach(group => {
        if ((group.dataset.optionName || '') === clickedOptionName) {
          const b = group.querySelector('.variant-btn');
          if (b) clickedPos = parseInt(b.dataset.optionPosition);
        }
      });
      const map = this.getSelectedMap();
      let candidates = this.variants;
      if (clickedPos && map[clickedPos] != null) {
        candidates = candidates.filter(v => v['option' + clickedPos] === map[clickedPos]);
      }
      variant = candidates.find(v => v.available) || candidates[0];
      if (variant) this.syncButtonsToVariant(variant);
    }

    if (!variant) return;

    if (this.hiddenSelect) this.hiddenSelect.value = variant.id;

    this.addToCartBtns.forEach(btn => {
      btn.dataset.variantId = variant.id;
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    });

    if (this.priceEl) {
      let html = '';
      if (variant.compare_at_price > variant.price) {
        html += `<span style="color:#7a6e62;text-decoration:line-through;font-size:18px;margin-right:8px;">${variant.compare_at_price_formatted}</span>`;
      }
      html += variant.price_formatted;
      this.priceEl.innerHTML = html;
    }

    if (variant.featured_image_index >= 0) {
      this.switchGalleryImage(variant.featured_image_index);
    }
  }

  switchGalleryImage(index) {
    const slides = document.querySelectorAll('.gallery-slide');
    const thumbs = document.querySelectorAll('.product-thumb');
    if (index >= slides.length) return;
    slides.forEach(s => s.classList.remove('active'));
    thumbs.forEach(t => t.classList.remove('active'));
    slides[index]?.classList.add('active');
    thumbs[index]?.classList.add('active');
  }
}

/* ─── STICKY ATC ─── */
class StickyATC {
  constructor() {
    this.bar = document.getElementById('sticky-atc');
    if (!this.bar) return;
    const mainBtn = document.querySelector('.btn-add-to-cart:not(.sticky-atc-btn)');
    if (!mainBtn) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        this.bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(mainBtn);
  }
}

/* ─── SIZE GUIDE ─── */
function initSizeGuide() {
  const overlay = document.getElementById('size-guide-overlay');
  if (!overlay) return;
  document.querySelectorAll('[data-size-guide]').forEach(el => {
    el.addEventListener('click', (e) => { e.preventDefault(); overlay.classList.add('is-open'); });
  });
  document.querySelectorAll('[data-size-guide-close]').forEach(el => {
    el.addEventListener('click', () => overlay.classList.remove('is-open'));
  });
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) overlay.classList.remove('is-open');
  });
}

/* ─── NEWSLETTER FORM ─── */
function initNewsletter() {
  document.querySelectorAll('.newsletter-form, .footer-newsletter-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]').value;
      const btn = form.querySelector('button');
      btn.textContent = '✓';
      btn.style.background = '#2a6a2a';
      setTimeout(() => {
        btn.textContent = 'Subscribe';
        btn.style.background = '';
      }, 3000);
    });
  });
}

/* ─── SLIDERS ─── */
function initSliders() {
  document.querySelectorAll('[data-slider-prev], [data-slider-next]').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.sliderPrev || btn.dataset.sliderNext;
      const track = document.getElementById(id);
      if (!track) return;
      const item = track.querySelector('.slider-item');
      const amount = item ? item.offsetWidth + 12 : 220;
      track.scrollBy({ left: btn.dataset.sliderNext ? amount : -amount, behavior: 'smooth' });
    });
  });
}

/* ─── HOMEPAGE INFINITE PRODUCT SLIDER ─── */
function initInfiniteProductSlider() {
  const track = document.getElementById('hp-products-track');
  if (!track) return;

  // Clone all cards twice for "almost infinite" scroll
  const originals = Array.from(track.children);
  if (!originals.length) return;
  [1, 2].forEach(() => {
    originals.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  });

  // Drag-to-scroll on desktop
  let isDown = false, startX = 0, scrollLeft = 0;
  track.addEventListener('mousedown', e => {
    isDown = true;
    track.classList.add('is-dragging');
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
    e.preventDefault();
  });
  window.addEventListener('mouseup', () => {
    isDown = false;
    track.classList.remove('is-dragging');
  });
  track.addEventListener('mousemove', e => {
    if (!isDown) return;
    const x = e.pageX - track.offsetLeft;
    track.scrollLeft = scrollLeft - (x - startX) * 1.2;
  });
  // Prevent click after drag
  track.addEventListener('click', e => {
    if (track.dataset.dragged === '1') {
      e.preventDefault();
      delete track.dataset.dragged;
    }
  });
  track.addEventListener('mousedown', () => { track.dataset.startScroll = track.scrollLeft; });
  track.addEventListener('mouseup', () => {
    if (Math.abs(track.scrollLeft - parseInt(track.dataset.startScroll || 0)) > 5) {
      track.dataset.dragged = '1';
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  new CartDrawer();
  new MobileMenu();
  new ProductGallery();
  new VariantSelector();
  new StickyATC();
  initNewsletter();
  initSliders();
  initSizeGuide();
  initInfiniteProductSlider();
});
